// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2475":"2867c268aca3979e","3557":"05d582fb644bed30","3706":"0979091743ccb587","5681":"cf62c00c92ba471f"}[chunkId] + ".js";
};